import { StorageDto } from 'data';

export const adminPortDomain = '5019';
export const publicPortDomain = '5018';
export const storageTypeDomain = StorageDto.type.MEMORY;
